module.exports = __webpack_public_path__ + "static/media/25.11625085.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/25.png
// module id = 1399
// module chunks = 0